  import React, { useState, useEffect } from 'react';
  import axios from 'axios';
  import { useLocation, useNavigate } from 'react-router-dom';
  import './InsertAnimalStatus.css';

  const InsertAnimalStatus = () => {
    const { state } = useLocation();
    const navigate = useNavigate();

    const { animal_cat, animal_subcat, day } = state || {};
    // console.log(animal_cat, animal_subcat);
    const [animals, setAnimals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [history, setHistory] = useState([]);
    const [showHistory, setShowHistory] = useState(false);

    useEffect(() => {
      if (!animal_cat || !animal_subcat || !day) return navigate('/');
      fetchAnimals();
    }, [animal_cat, animal_subcat, day]);
    
const fetchAnimals = async () => {
  try {
    
    const { data } = await axios.post(
      `https://apiiq.jamamasjidquba.com/api/animals/search/${animal_cat}/${animal_subcat}/${day}`,
      {},
      { withCredentials: true }  // 👈 config goes here, not as request body
    );

    console.log(data);
    setAnimals(data.data);
    setError('');
  } catch (err) {
    setAnimals([]);
    setError(
      err.response?.status === 404
        ? 'No matching animal data found'
        : 'Failed to fetch animal data'
    );
  } finally {
    setLoading(false);
  }
};
const updateStatus = async (id, newStatus) => {
  try {
    await axios.post(
      `https://apiiq.jamamasjidquba.com/api/animals/status/${id}/${encodeURIComponent(newStatus)}`
    );
    fetchAnimals(); // refresh after update
  } catch (err) {
    console.error(err);
    setError('Failed to update status');
  }
};

    const viewHistory = async (animalNo) => {
      try {
        const { data } = await axios.get(`https://apiiq.jamamasjidquba.com/api/animals/status-history/${animalNo}`);
        setHistory(data.data);
        setShowHistory(true);
      } catch (err) {
        setError('Failed to fetch status history');
      }
    };

    return (
      <div className="animal-status-container">
        <h2>Animal Status Dashboard</h2>

        <div><strong>Category:</strong> {animal_cat} | <strong>Subcategory:</strong> {animal_subcat} | <strong>Day:</strong> {day}</div>

        {loading ? <div className="loading">Loading...</div> : (
          <>
            {error && <div className="error">{error}</div>}
            <table className="results-table">
              <thead>
                <tr>
                  {/* <th>ID</th> */}
                  <th>Animal No</th>
                  <th>Current Status</th>
                  <th>Update</th>
                  <th>History</th>
                </tr>
              </thead>
              <tbody>
                {animals.length ? animals.map(a => (
                  <tr key={a.id}>
                    {/* <td>{a.id}</td> */}
                    <td>{a.animal_no}</td>
                   <td>{a.ani_status?.trim() ? a.ani_status : 'Not Slaughtered'}</td>

                    <td>
                      <select value={a.status || ''}
                       onChange={e => updateStatus(a.id, e.target.value)}
                      >
                        <option value="">Select Status</option>

                        <option value="Slaughtered">Slaughtered</option>
                        <option value="In-Process">In Process</option>
                        <option value="Transported">Transported</option>
                        <option value="Ready-For-Delivery">Ready For Delivery</option>
                        <option value="Delivered">Delivered</option>
                      </select>
                    </td>
                    <td>
                      <button className="history-btn" onClick={() => viewHistory(a.animal_no)}>View History</button>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan="5">No animals found.</td></tr>
                )}
              </tbody>
            </table>
          </>
        )}

        {showHistory && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Status History</h3>
              <button className="close-btn" onClick={() => setShowHistory(false)}>×</button>
              <table className="history-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((h, i) => (
                    <tr key={i}>
                      <td>{new Date(h.created_at).toLocaleString()}</td>
                      <td>{h.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  };

  export default InsertAnimalStatus;
